import React, { useState } from "react";
import styles from "./Account.module.scss";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../../contexts/ThemeContext";
import MessageIcon from "../../../assets/icons/profile/MessageIcon";
import ChannelsIcon from "../../../assets/icons/accountSidebar/ChanalesIcon";
import DatabaseIcon from "../../../assets/icons/accountSidebar/DatabaseIcon";
import NewsLetterIcon from "../../../assets/icons/accountSidebar/NewsLetterIcon";
import TeamIcon from "../../../assets/icons/accountSidebar/TeamIcon";
import PaymentsIcon from "../../../assets/icons/accountSidebar/PaymentsIcon";
import Messages from "../../../components/Account/Messages/Messages";
import Channels from "../../../components/Account/Channels/Channels";
import Database from "../../../components/Account/Database/Database";
import Newsletter from "../../../components/Account/Newsletter/Newsletter";
import Team from "../../../components/Account/Team/Team";
import Payments from "../../../components/Account/Payments/Payments";
import CRMIcon from "../../../assets/icons/accountSidebar/CRMIcon";
import Crm from "../../../components/Account/Crm/Crm";
import Bots from "../../../components/Account/Bots/Bots";

const Account = () => {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState("messages");
  const { theme } = useTheme();

  const sections = [
    { id: "messages", name: t("sections.messages"), icon: <MessageIcon /> },
    { id: "channeles", name: t("sections.channeles"), icon: <ChannelsIcon /> },
    { id: "databases", name: t("sections.databases"), icon: <DatabaseIcon /> },
    { id: "bots", name: t("sections.bots"), icon: <CRMIcon /> },

    {
      id: "newsletters",
      name: t("sections.newsletters"),
      icon: <NewsLetterIcon />,
    },
    { id: "team", name: t("sections.team"), icon: <TeamIcon /> },
    { id: "payments", name: t("sections.payments"), icon: <PaymentsIcon /> },
  ];

  const components = {
    messages: <Messages />,
    channeles: <Channels />,
    databases: <Database />,
    bots: <Bots />,

    // crm: <Crm />,
    newsletters: <Newsletter />,
    team: <Team />,
    payments: <Payments />,
  };

  return (
    <div className={styles.accountPage}>
      <h1 className={styles.title}>{t("pageAccountTitle")}</h1>
      <section className={styles.accountContainer}>
        <aside className={styles.settingsNavigation}>
          {sections.map((section) => (
            <button
              key={section.id}
              onClick={() => setActiveSection(section.id)}
              className={`${styles.navigationButton} ${
                activeSection === section.id ? styles.activeButton : ""
              }`}
            >
              {React.cloneElement(section.icon, {
                color:
                  theme === "dark"
                    ? activeSection === section.id
                      ? "#0A61F5"
                      : "white"
                    : activeSection === section.id
                    ? "#0A61F5"
                    : "#000000",
              })}
              <span>{section.name}</span>
            </button>
          ))}
        </aside>
        <main className={styles.accountContent}>
          {components[activeSection] || null}
        </main>
      </section>
    </div>
  );
};

export default Account;
